module.exports = __webpack_public_path__ + "img/cards.c6e12e4b.jpg";